import { useQuery, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";

export function useList(key, url, options = {}) {
  return useQuery({
    queryKey: Array.isArray(key) ? key : [key],
    queryFn: async () => (await api.get(url)).data,
    ...options,
  });
}

export function useUsersMap() {
  const { data } = useQuery({
    queryKey: ["users"],
    queryFn: async () => (await api.get("/users")).data,
  });
  const users = data || [];
  const map = {};
  users.forEach((u) => { map[u.id] = u; });
  return { users, map };
}

export function useInvalidate() {
  const qc = useQueryClient();
  return (keys) => (Array.isArray(keys) ? keys : [keys]).forEach((k) => qc.invalidateQueries({ queryKey: [k] }));
}
